import { PayrollDetail } from "./payroll.detail";

export class Payroll {
    id: number;
    dateFrom: string;
    dateTo: string;
    type: string;
    payrollDetails: PayrollDetail[];

    constructor(){
        this.id = 0;
        this.payrollDetails = [];
    }
}


// WEBPACK FOOTER //
// ./src/app/models/salaries/payroll.ts